<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
		<g id="Component_1237_3" data-name="Component 1237 – 3" transform="translate(2 2)">
			<g id="Group_44754" data-name="Group 44754" transform="translate(0 0)">
				<path
					id="Path_30437"
					data-name="Path 30437"
					d="M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0"
					transform="translate(0 0)"
					fill="#7e7fe7"
					stroke="#5b5be6"
					stroke-width="4"
				/>
			</g>
		</g>
		<path
			id="Path_30439"
			data-name="Path 30439"
			d="M6.75,5.825A1.325,1.325,0,0,1,8.075,4.5h2.651a1.325,1.325,0,0,1,1.325,1.325V29.684a1.325,1.325,0,0,1-1.325,1.325H8.075A1.325,1.325,0,0,1,6.75,29.684ZM20,5.825A1.325,1.325,0,0,1,21.33,4.5h2.651a1.325,1.325,0,0,1,1.325,1.325V29.684a1.325,1.325,0,0,1-1.325,1.325H21.33A1.325,1.325,0,0,1,20,29.684Z"
			transform="translate(16.25 14.245)"
			fill="#fff"
			fill-rule="evenodd"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PauseSvg',
};
</script>

<style scoped lang="scss"></style>
